import { AllhomesGlobalContextConsumer } from './consumer';
export * from './allhomes-global-context';
export * from './with-allhomes-context';
export * from './with-allhomes-provider';
export * from './provider';
export * from './hook';
export * from './consumer';
export var withAllhomesContextProxy = identity => identity;
export default AllhomesGlobalContextConsumer;